import { HttpParams } from '@angular/common/http';

import { FSA_COUNTRY_CODE, QUALIFICATION_CODE } from '@ps/survey-utils';

export class LocationUploadParamsMapper {
  public toHttpParams(
    surveyId: number,
    countryCode: string,
    qualificationCode: number,
  ): HttpParams {
    let params = new HttpParams().set('survey', surveyId);
    if (this._isFsaUpload(countryCode, qualificationCode)) {
      params = params.set('type', 'fsa');
    }

    return params;
  }

  private _isFsaUpload(
    countryCode: string,
    qualificationCode: number,
  ): boolean {
    return (
      countryCode === FSA_COUNTRY_CODE &&
      qualificationCode === QUALIFICATION_CODE.FSA
    );
  }
}
